/**
 * Branded ID types for the Evolu database schema.
 *
 * Each table in the schema has a branded ID type that provides
 * compile-time type safety -- you cannot accidentally pass a
 * TransactionId where a ContactId is expected.
 *
 * @module db/schema-ids
 */

import { id } from '@evolu/common';

export const WalletConnectionId = id('WalletConnection');
export type WalletConnectionId = typeof WalletConnectionId.Type;

export const CashuMintId = id('CashuMint');
export type CashuMintId = typeof CashuMintId.Type;

export const CashuTokenId = id('CashuToken');
export type CashuTokenId = typeof CashuTokenId.Type;

export const TransactionId = id('Transaction');
export type TransactionId = typeof TransactionId.Type;

export const ContactId = id('Contact');
export type ContactId = typeof ContactId.Type;

export const CategoryId = id('Category');
export type CategoryId = typeof CategoryId.Type;

export const SettingId = id('Setting');
export type SettingId = typeof SettingId.Type;

export const UserIdentityId = id('UserIdentity');
export type UserIdentityId = typeof UserIdentityId.Type;

export const MessageId = id('Message');
export type MessageId = typeof MessageId.Type;

export const GroupId = id('Group');
export type GroupId = typeof GroupId.Type;

export const GroupMemberId = id('GroupMember');
export type GroupMemberId = typeof GroupMemberId.Type;

export const ExpenseId = id('Expense');
export type ExpenseId = typeof ExpenseId.Type;

export const GroupJarId = id('GroupJar');
export type GroupJarId = typeof GroupJarId.Type;

export const RecoveryConfigId = id('RecoveryConfig');
export type RecoveryConfigId = typeof RecoveryConfigId.Type;

export const RecoveryClaimId = id('RecoveryClaim');
export type RecoveryClaimId = typeof RecoveryClaimId.Type;

export const CashuCounterId = id('CashuCounter');
export type CashuCounterId = typeof CashuCounterId.Type;
